/**
 * textFormatter — la casse et le compte d'un mot, pour une copie écrite une fois et lue à deux
 * endroits : en tête d'une ligne (« Mercredi 16h ») et dans une phrase (« le mercredi 16h »).
 */

/** La première lettre en capitale, le reste tel quel — « mercredi 16h » → « Mercredi 16h ». */
export function capitalizeFirst(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

/** La première lettre en minuscule, le reste tel quel — « Mercredi 16h » → « mercredi 16h ». */
export function lowerFirst(text: string): string {
    return text.charAt(0).toLowerCase() + text.slice(1)
}

/** Une énumération française — « mardi 17h », « mardi 17h et samedi 10h », « a, b et c ». */
export function joinFrench(items: string[]): string {
    if (items.length <= 1) return items[0] ?? ""
    return `${items.slice(0, -1).join(", ")} et ${items[items.length - 1]}`
}

/**
 * Une phrase qui finit sur un texte qui a peut-être déjà son point — un nom de salle et son initiale, « Thérèse
 * P. » : la ponctuation n'est ajoutée que s'il ne finit pas déjà par un point (« Thérèse P.. », relevé le 03/11).
 */
export function endSentence(text: string, mark = "."): string {
    return text.endsWith(".") ? text : `${text}${mark}`
}

/** Un nombre et son nom, accordé — « 1 place », « 2 places ». `plural` pour un pluriel irrégulier. */
export function countLabel(count: number, singular: string, plural = `${singular}s`): string {
    return `${count} ${Math.abs(count) > 1 ? plural : singular}`
}

const NUMBER_WORDS = [
    "zéro",
    "un",
    "deux",
    "trois",
    "quatre",
    "cinq",
    "six",
    "sept",
    "huit",
    "neuf",
    "dix",
    "onze",
    "douze",
    "treize",
    "quatorze",
    "quinze",
    "seize",
    "dix-sept",
    "dix-huit",
    "dix-neuf",
    "vingt",
]

/**
 * Un petit nombre en toutes lettres, pour une phrase — « deux », « dix-sept ». Au-delà de vingt, ou
 * pour un nombre qui n'est pas un entier positif, ses chiffres.
 */
export function numberInWords(count: number): string {
    return Number.isInteger(count) && count >= 0 ? (NUMBER_WORDS[count] ?? String(count)) : String(count)
}
